// @flow

import React from "react";
import "./NextButton.scss";
import {useTranslation} from "react-i18next";

export type NextButtonProps = {
    onClick: () => void,
    disabled?: boolean,
    children?: any,
    style?: any,
}

const NextButton = (props: NextButtonProps) => {
    const {t} = useTranslation();
    return (
        <button
            {...props}
            type={"button"}
            style={props.style}
            className={"hpm-button hpm-cartButton"} onClick={props.onClick}
            disabled={props.disabled || false}
        >
            {props.children ? props.children : t("cart.next")}
        </button>
    );
};

export default NextButton;
